angular.module( 'acme.view.application.coupons.categories.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.coupons.categories.create.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var couponsCategoriesCreate = {
        name: 'application.coupons.categories.create',
        url: '/create/:id',
        views: {
          "subview-main@application.coupons": {
            controller: 'CouponsCategoriesCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/coupons/categories/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Coupon Category',
          /** Secure With Roles **/
          permissions: ['COUPON_CATEGORIES_VIEW']
        }
      };

    $stateProvider
      .state(couponsCategoriesCreate);
});
